// Add a key to descbribe what endpoint and a regular expression to match that endpoint where accessToken is required
const ACCESS_TOKEN_REGEX_LIST = {
    // example = login: /j_spring_security_check/
    // To trigger LOS API call for POC reasons ONLY - NEVER GOES INTO PRODUCTION BCISO-537
    losPocEndpoint: /https:\/\/dev.gateway.api.hmgroup.tech\/los-amt-sandbox\//,
};
const MIN_ACCESS_TOKEN_EXPIRE_IN_MINUTES = 2;
export { ACCESS_TOKEN_REGEX_LIST, MIN_ACCESS_TOKEN_EXPIRE_IN_MINUTES };
//# sourceMappingURL=constants.js.map